import type { Observable as ObservableType } from 'rxjs/Observable';
import { mutation$ } from '@atlassian/jira-software-swag/src/services/mutation/index.tsx';
import type { MutationInput, CardCreateGql } from './types.tsx';

const MUTATION_NAME = 'BacklogCreateCard';

export const getMutation = () => `
    mutation ${MUTATION_NAME} (
        $boardId: ID!,
        $destination: PlanModeDestination!,
        $destinationId: ID,
        $newCards: [NewCard!]!,
        $rankBeforeCardId: Long
    ) {
        planModeCardCreate(input: {
            boardId: $boardId,
            destination: $destination,
            destinationId: $destinationId,
            newCards: $newCards,
            rankBeforeCardId: $rankBeforeCardId
        }) {
            newCards {
                id
                flagged
                done
                parentId
                fixVersions
                issue {
                    id
                    key
                    summary
                    labels
                    status {
                        id
                        name
                        category
                    }
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                    type {
                        id
                        name
                        iconUrl
                    }
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }
        }
    }`;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: string, input: MutationInput): ObservableType<CardCreateGql> => {
	const { boardId, destination, destinationId, newCards, rankBeforeCardId } = input;
	const variables = {
		boardId,
		destination,
		destinationId,
		newCards,
		rankBeforeCardId,
	};

	return mutation$<CardCreateGql>(baseUrl, MUTATION_NAME, getMutation(), variables);
};
